/**
 * Difusor de Fluxo (DF) — Arena do Investidor / Trade ao Vivo.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLXPI.cs:143, classe FML.DF;
 * idêntica em FMLClear.cs:163 e FMLRico.cs:172 — provado na leva v1.2).
 * Derivado do MACD com uma média extra de longo período. Painel próprio,
 * 3 linhas, SEM histograma:
 *
 *   DIFF = EMA(CLOSE, SHORT) − EMA(CLOSE, LONG)   ("DIFUSOR TAV")
 *   DF−  = EMA(DIFF, DF_MENOS)
 *   DF+  = EMA(DIFF, DF_MAIS)
 *
 * O EMA do engine é DMA(f, 2/(N+1)) com seed out[0] = f[0] — NÃO tem warm-up
 * NaN: as três séries emitem desde a barra 0 (na barra 0 as duas EMAs valem
 * C[0] → tudo 0). Confirmado nos 5 oráculos (nonNull = 2000). Paridade em
 * __tests__/difusorFluxo.silverlight.test.js.
 */
import { ema, sub } from "./silverlightDsl";
import { DifusorFluxo as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { long, short, dfMenos, dfMais } = options;
    const close = data.map((d) => (Number.isFinite(d.close) ? d.close : NaN));

    // Ordem do engine preservada (Run() linha a linha).
    const diff = sub(ema(close, short), ema(close, long));
    const dfMinus = ema(diff, dfMenos);
    const dfPlus = ema(diff, dfMais);

    return diff.map((dv, i) => {
      const diffOut = Number.isFinite(dv) ? dv : undefined;
      const menosOut = Number.isFinite(dfMinus[i]) ? dfMinus[i] : undefined;
      const maisOut = Number.isFinite(dfPlus[i]) ? dfPlus[i] : undefined;
      if (
        diffOut === undefined &&
        menosOut === undefined &&
        maisOut === undefined
      )
        return undefined;
      return { diff: diffOut, dfMenos: menosOut, dfMais: maisOut };
    });
  }

  calculator.undefinedLength = function () {
    // EMA com seed f[0] não gera warm-up NaN — emite desde a barra 0.
    return 0;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
